import { render, staticRenderFns } from "./TabDraft.vue?vue&type=template&id=4b671b52&"
import script from "./TabDraft.vue?vue&type=script&lang=js&"
export * from "./TabDraft.vue?vue&type=script&lang=js&"
import style0 from "./TabDraft.vue?vue&type=style&index=0&id=4b671b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports